'use client'

import { FC } from 'react'

import Image from 'next/image'

import bgLogin from '@@/images/bg_login.png'

import { NewSignInForm } from './components'
import { ISignInFormProps } from './types'

const SignInForm: FC<ISignInFormProps> = ({ isRememberMe, savedLoginUser }) => {
  return (
    <div className="flex w-screen min-h-screen">
      <div className="flex flex-1 items-stretch">
        {/* Bloco do formulário */}
        <div className="flex flex-1 flex-col justify-start items-center p-8 bg-white gap-8 overflow-y-auto">
          <div className="flex flex-col items-start justify-center w-full max-w-[437px] bg-white gap-8 min-h-max h-full">
            <NewSignInForm
              isRememberMe={isRememberMe}
              savedLoginUser={savedLoginUser}
            />
          </div>
        </div>

        {/* Bloco da imagem */}
        <div className="relative hidden md:flex flex-1 h-full">
          <Image
            src={bgLogin}
            alt="Homem segurando cartão da onlypay"
            fill
            className="object-cover object-center"
            priority
          />
        </div>
      </div>
    </div>
  )
}

export default SignInForm
